// PayrollManagement 전용 로깅 설정
import { createLogger } from './logger.ts';
import { getPerformanceConfig, shouldLog } from './performanceConfig.ts';

// PayrollManagement 전용 로거
export const payrollLogger = createLogger('PayrollManagement');

// 각 기능별 로거들
export const dataLogger = createLogger('PayrollData');
export const calculationLogger = createLogger('PayrollCalculations');
export const adjustmentLogger = createLogger('PreviousMonthAdjustment');
export const teamLogger = createLogger('TeamManagement');
export const employeeLogger = createLogger('EmployeeManagement');

// 로깅 카테고리별 헬퍼 함수들
export const logDataOperation = (operation: string, data?: any) => {
  dataLogger.debug(`${operation}`, data);
};

export const logCalculation = (calculation: string, input?: any, result?: any) => {
  calculationLogger.debug(`${calculation}`, { input, result });
};

export const logAdjustment = (action: string, details?: any) => {
  adjustmentLogger.info(`${action}`, details);
};

export const logTeamOperation = (operation: string, teamName: string, details?: any) => {
  teamLogger.debug(`${operation}: ${teamName}`, details);
};

export const logEmployeeOperation = (operation: string, employeeName: string, details?: any) => {
  employeeLogger.debug(`${operation}: ${employeeName}`, details);
};

// 성능 중요 작업을 위한 로깅 (주파수 제한 적용)
export const logPerformanceCritical = (operation: string, data?: any) => {
  const config = getPerformanceConfig();
  if (!config.enablePerformanceLogs) return;
  
  const logKey = `performance:${operation}`;
  if (!shouldLog(logKey, config)) return;
  
  payrollLogger.debug(`⚡ ${operation}`, data);
};

// 에러 로깅 (항상 활성화)
export const logError = (operation: string, error: any, context?: any) => {
  payrollLogger.error(`${operation} failed`, { error: error.message || error, context });
};

// 중요한 비즈니스 로직 로깅 (프로덕션에서도 유지)
export const logBusinessEvent = (event: string, details?: any) => {
  payrollLogger.info(`📊 ${event}`, details);
};

// 사용자 액션 로깅 (프로덕션에서도 유지)
export const logUserAction = (action: string, details?: any) => {
  payrollLogger.info(`👤 User: ${action}`, details);
};

// 개발 전용 상세 디버깅
export const logDebugDetails = (message: string, details?: any) => {
  if (process.env.NODE_ENV === 'development') {
    payrollLogger.debug(`🔍 ${message}`, details);
  }
};

// 그룹 로깅 헬퍼
export const startLogGroup = (label: string) => {
  payrollLogger.group(label);
};

export const endLogGroup = () => {
  payrollLogger.groupEnd();
};

// 조건부 로깅 (성능 최적화)
export const logIf = (condition: boolean, level: 'debug' | 'info' | 'warn' | 'error', message: string, data?: any) => {
  if (!condition) return;
  
  switch (level) {
    case 'debug':
      payrollLogger.debug(message, data);
      break;
    case 'info':
      payrollLogger.info(message, data);
      break;
    case 'warn':
      payrollLogger.warn(message, data);
      break;
    case 'error':
      payrollLogger.error(message, data);
      break;
  }
};